import React from 'react';

const GridIcon = ({ rows, columns, size = 14, gap = 1, radius = 0.5 }) => {
    const cellWidth = (size - gap * (columns - 1)) / columns;
    const cellHeight = (size - gap * (rows - 1)) / rows;

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="currentColor" aria-hidden="true">
            {Array.from({ length: rows * columns }).map((_, index) => {
                const row = Math.floor(index / columns);
                const column = index % columns;
                const x = column * (cellWidth + gap);
                const y = row * (cellHeight + gap);

                return <rect key={`${row}-${column}`} x={x} y={y} width={cellWidth} height={cellHeight} rx={radius} />;
            })}
        </svg>
    );
};

export default GridIcon;


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/GridIcon.jsx